import { render, staticRenderFns } from "./vouchers.vue?vue&type=template&id=08c7bb20&"
import script from "./vouchers.vue?vue&type=script&lang=js&"
export * from "./vouchers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports